<template>
  <div ref="echartsContainer" style="width:600px; height: 300px;"></div>
</template>
   
  <script>
import * as echarts from "echarts";

export default {
  name: "EChartsComponent",
  props: {
    data: Array,
  },
  mounted() {
    let equity_data = [],
      record_date = [];
      
    this.data.forEach((item) => {
      equity_data.push(item.total_profit);
      record_date.push(item.record_date);
    });
    var myChart = echarts.init(this.$refs.echartsContainer);
    myChart.setOption({
      // tooltip: {
      //   trigger: "axis", // 触发类型
      //   confine: true, //将 tooltip 框限制在图表的区域内。
      //   textStyle: {
      //     fontSize: 12,
      //     color: "#E7EEF8",
      //   },
      //   backgroundColor: "#8EA4BD", //设置背景图片 rgba格式
      //   borderColor: "#2D3D5C",
      //   formatter(obj) {
      //     var value = obj[0].data;
      //     var date = obj[0].axisValue;
          
      //     return (
      //       "<div>" +
      //       '$'+value+
      //       "<br />" +
      //       ''+date+
      //       "</div>"
      //     );
      //   },
      // },
      xAxis: {
        data: record_date,
        type: "category",
        boundaryGap: false,
        // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        axisTick: {
              // 轴刻度
              show: false,
            },
            axisLine: {
            // 轴线
            show: false
          }
      },
      axisLabel: {
        // 轴文字
        show: false,
        color: "#888891",
        fontSize: 12
      },
      axisLine: {
        // 轴线
        show: true,
        color: "#888891"
      },

      yAxis: [
        {
          type: "value",
          axisTick: {
              // 轴刻度
              show: false,
            },
            axisLine: {
            // 轴线
            show: false
          }
        },
        
      ],
      dataset: {
        source: this.data,
      },
      series: [
        {
          // data: [150, 230, 224, 218, 135, 147, 260],
          type: "line",
          data: equity_data,
           // 设置折线颜色
        lineStyle: {
            color: '#60ADFF', // 折线颜色
            width: 1, // 折线宽度
        },
        symbol: "none",
        // 设置数据点颜色
        itemStyle: {
            color: '#60ADFF', // 数据点颜色
             borderWidth: 1,
                borderColor: '#60ADFF'
        },
        areaStyle: {
          color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color:'#60ADFF', // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#fff', // 100% 处的颜色
                  // color: "rgba(255,000,000,0.08)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
        }
        }
      ]
    });
  }
};
</script>
<style scoped>
</style>